import PropTypes from 'prop-types'
import { useEffect } from 'react'
import EventEmitter, {
  SHOW_SELECT_CUSTOM,
} from '../../../../helpers/EventEmitter'
import classes from './LeftFilter.module.scss'

export const InputItem = ({
  defaultValue,
  value,
  setValue,
  disabled,
  keyItem,
  style,
  placeholder,
}) => {
  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  const onChange = (e) => {
    setValue(e.target.value)
  }

  const onFocus = () => {
    setValue('')
  }

  const onClick = (e) => {
    e.stopPropagation()
    EventEmitter.dispatch(SHOW_SELECT_CUSTOM, { id: keyItem })
  }

  return (
    <input
      className={classes.inputCustom}
      disabled={disabled}
      value={value}
      style={style}
      onClick={onClick}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={placeholder}
    />
  )
}

InputItem.propTypes = {
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  keyItem: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string,
}

InputItem.defaultProps = {
  value: '',
  style: {},
  placeholder: '',
}
